import React, { useEffect } from "react";
import { IProducts } from "../../../store/cyberRiskProfile/types";
import { staticURLs } from "../../../config/urls";
import RenderIcons from "../../../Assets/css/_icons/partner_icon/RenderIcons";

const BundleFeatures = (props: any) => {
    useEffect(() => {
        document.querySelector<any>(`[aria-labelledby=${props.dialogId}-title]`)!.classList.add("width-lg");
        window.addEventListener("keyup", (evt: any) => {
            evt = evt || window.event;
            var isEscape = false;
            if ("key" in evt) {
                isEscape = evt.key === "Escape" || evt.key === "Esc";
            } else {
                isEscape = evt.keyCode === 27;
            }
            if (isEscape) {
                props.closeDialog();
            }
        });
        return () => {
            window.removeEventListener("keyup", () => {});
        };
    });

    return (
        <React.Fragment>
            <div className="dialog-header">
                <div className="dialog-icon status-default">
                    <RenderIcons iconName="cube" />
                </div>
                <div className="box-title-text">
                    <h1 className="box-title">{props.Type}</h1>
                </div>
                <div className="margin-top-xl"></div>
            </div>

            <div className="dialog-body small-dialog-scroll">
                {props.Products?.map((product: IProducts, index: number) => (
                    <React.Fragment key={`bundle-product-${index}`}>
                        <div className="row">
                            <div role="option" className="row">
                                <img src={product.ProductImageURL} style={{ width: "250px" }} alt={product.Name} />
                            </div>
                            <div className="card">
                                <div className="card-body">
                                    <h4 className="emphasize-3">{product.Name}</h4>
                                </div>
                            </div>
                            <div className="box-description">
                                <p>{product.Description}</p>
                            </div>
                            <div className="box-description">
                                <p>
                                    Product Category:
                                    {product.categories?.map((category: any, i: number) => (
                                        <span key={"category-" + i}>
                                            {" " + category.description}
                                            {i < product.categories?.length! - 1 && ","}
                                        </span>
                                    ))}
                                </p>
                            </div>
                        </div>
                        <div className="line-divider margin-vertical-m"></div>
                    </React.Fragment>
                ))}
            </div>

            <div className="dialog-footer">
                <div className="row between-xs">
                    <div className="col-xs col-no-gutter flex-grow-null">
                        <button type="button" className="btn-default btn-link" onClick={props.callback}>
                            <span className="btn-text">Close</span>
                        </button>
                    </div>
                    <div className="col-xs col-no-gutter flex-grow-null">
                        <a href={staticURLs.SMBCyberRiskScheduleConsultation} target="_blank" className="btn-default btn-primary" rel="noreferrer">
                            <span className="btn-text">Schedule Consultation</span>
                        </a>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default BundleFeatures;
